import MDBox from "@vendor/components/MDBox";
import { MainLayout } from "@shared/ui/MainLayout";
import { DashboardItems } from "../components/DashboardItems";

export const DashboardPage = () => (
  <MainLayout loading={false}>
    <MDBox py={3}>
      <DashboardItems />
    </MDBox>
  </MainLayout>
);
